import React, { } from "react";
import { Card, Col, Row, } from "react-bootstrap";

function ReviewDetails({ trialNow, previous }) {

    return (
        <>
            <div className="mt-3">
                <div  className="pt-4">
                <div className="text-center" style={{color:'#58d9cf',fontWeight:'bold'}}>Step 2</div>
                    <div style={{ fontWeight: "bold", fontSize: "22px" }} className="mb-4 text-center">Your Order</div>
                </div>
                <form className="p-3 form-group">
                    <Row className="pt-1 ps-1" style={{background: '#ebebeb',marginLeft:"5px",marginRight:"5px"}}>
                        <Col className="col-8" style={{padding:"0px"}}>
                            <label className="form-label"><b>Product</b></label>
                        </Col>
                        <Col className="col-4">
                            <label className="form-label"><b>Subtotal</b></label>
                        </Col>
                    </Row>
                    <Row className="pt-1 ps-1" style={{marginLeft:"5px",marginRight:"5px"}}>
                        <Col className="col-8" style={{padding:"0px"}}>
                            <label className="form-label">Attendant 2 Hours Trial Service  × 1	</label>
                        </Col>
                        <Col className="col-4">
                            <label className="form-label">₹299.00</label>
                        </Col>
                    </Row>
                    <Row className="pt-1 ps-1" style={{marginLeft:"5px",background: '#ebebeb',marginRight:"5px"}}>
                        <Col className="col-8" style={{padding:"0px"}}>
                            <label className="form-label">Subtotal</label>
                        </Col>
                        <Col className="col-4">
                            <label className="form-label">₹299.00</label>
                        </Col>
                    </Row>
                    <Row className="pt-1 ps-1" style={{marginLeft:"5px",marginRight:"5px"}}>
                        <Col className="col-8" style={{padding:"0px"}}>
                            <label className="form-label"><b>Total</b></label>
                        </Col>
                        <Col className="col-4">
                            <label className="form-label">	<b>₹299.00</b></label>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col className="col-4" >
                            <button type="button" className="btn" style={{ backgroundColor: "#2b7dbd", color: "white" }} onClick={() => {
                                previous();
                            }}>Previous</button>
                        </Col>
                        <Col className="col-8 text-end">
                            <button type="button" className="btn" style={{ backgroundColor: "#2b7dbd", color: "white" }} onClick={() => {
                                trialNow();
                            }}>Pay ₹299 to Book Trail</button>
                        </Col>
                    </Row>
                </form>
            </div >
        </>
    );
}

export default ReviewDetails